<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  height: 100%;
}
</style>

<template>
  <div style="display: inline;">
    <div class="container" ref="container">
      <div class="form" ref="form">
        <el-form size="mini" :model="conditions" :inline="true">
          <el-form-item :label="$t('shebeimingcheng')">
            {{ $attrs.checkRecord.equipmentName }}
          </el-form-item>
          <el-form-item :label="$t('dangyueleijidianjiancishu')" label-width="200px">{{ info.totalBill }} </el-form-item><br />
          <el-form-item :label="$t('xuanzeyuefen')">
            <yi_time_input format="yyyy-MM" :type="'month'" :time.sync="conditions.planTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getCheckDaily" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </div>

      <!-- table -->
      <div class="table" style="margin-top: 8px;">
        <!-- <el-table :data="currentData" size="mini" :fit="true" :show-header="true"  :max-height="tableHeight" style="width: 100%"
					:header-cell-style="{background: '#F5F7FA',color:'#606266', 'font-weight':'700', height:'48px', padding:'0px'}"> -->
        <el-table max-height="600" :data="currentData" size="mini" border style="width: 100%" v-loading="tableLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
          <el-table-column :label="$t('dianjianfenzu')" prop="group"></el-table-column>
          <el-table-column width="120" :label="$t('dianjianneirong')" prop="content"></el-table-column>
          <el-table-column width="120" :label="$t('zhuyishixiang')" prop="attention"></el-table-column>
          <el-table-column v-for="(item, index) in checkDaily.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" width="40">
            <template slot-scope="scope">
              <template v-if="scope.row[item.prop] === 0">
                <span style="font-size: 18px;">×</span>
              </template>
              <template v-if="scope.row[item.prop] === 1">
                <span style="font-size: 18px;">√</span>
              </template>
              <template v-if="scope.row[item.prop] === 2"> </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div ref="page" class="block" style="display: flex;justify-content: flex-end;padding-top: 20px;">
        <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 100, 500]" :page-size.sync="currentSize" layout="total, sizes, prev, pager, next, jumper" :total="checkDaily.tableData.length"> </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_equipment_resume_check_record',
  data() {
    return {
      tableLoading: false,
      tableHeight: 0,
      currentPage: 1,
      currentSize: 10,
      conditions: {
        equipmentId: '',
        planTime: ''
      },
      info: {
        totalBill: '', //当月点检单
        total: 0 //数据总条数
      },
      checkDaily: {
        tableData: [],
        tableColumn: [],
        // currentEquipment: '设备名称',
        currentDate: ''
      },
      key: 0,
      show: true
    };
  },
  created() {
    setTimeout(() => {
      this.setDefaultTime();
      this.getCheckDaily();
    }, 300);
  },
  mounted() {
    this.resize();
  },
  watch: {
    conditions: {
      handler(n) {
        // if (n.equipmentId !== '') {
        //   this.checkDaily.currentEquipment = '设备名称 ' + this.$attrs.checkRecord.equipmentName
        // }
        // if (n.planTime !== null) {
        //   this.checkDaily.currentDate = this.timestampToTime(n.planTime)
        // }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    currentData() {
      return this.checkDaily.tableData.slice((this.currentPage - 1) * this.currentSize, (this.currentPage - 1) * this.currentSize + this.currentSize);
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = val;
      this.click();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.click();
    },
    resize() {
      setTimeout(() => {
        if (!this.$refs.form) {
          return;
        }
        this.tableHeight = this.$refs.container.offsetHeight - this.$refs.form.offsetHeight - this.$refs.page.offsetHeight - 20;
      }, 500);
    },
    // 日期转换
    timestampToTime(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + '-';
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return Y + M;
    },
    // 重置
    reset() {
      this.setDefaultTime();
      // this.yt.get(1);
      this.getCheckDaily();
    },
    // 搜索
    getCheckDaily() {
      this.tableLoading = true;
      this.show = false;
      this.conditions.equipmentId = this.$attrs.checkRecord.equipmentId;
      let requestParam = {
        ...this.conditions
      };
      return this.http
        .get('/web/report/daily/check?' + this.qs.stringify(requestParam))
        .then(response => {
          this.info.totalBill = response.data.extend.totalBill.length;
          this.info.total = response.data.total;
          const rows = response.data.rows || [];
          this.checkDaily.tableColumn = [];
          this.checkDaily.tableData = [];
          if (rows.length > 0) {
            const item = rows[0];
            for (let i in item) {
              if (i === 'attention') {
                continue;
              }
              if (i === 'content') {
                continue;
              }
              if (i === 'group') {
                continue;
              }
              this.checkDaily.tableColumn.push({
                label: i,
                prop: i,
                width: 5
              });
            }
            this.checkDaily.tableColumn.sort(this.sortProp);
            this.checkDaily.tableData = rows;
          }
          this.show = true;
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    //取当前年份-月份
    getCurrentYearAndMonth() {
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      var tMonth = myDate.getMonth();

      var m = tMonth + 1;
      if (m.toString().length == 1) {
        m = '0' + m;
      }
      var time = myDate.parse(tYear + '-' + m);
      console.log('year', time);
      return tYear + '-' + m;
    },
    // 排序
    sortProp(a, b) {
      return a.prop - b.prop;
    },
    setDefaultTime() {
      var currentMonthDate = new Date();
      currentMonthDate.setDate(1);
      currentMonthDate.setHours(0);
      currentMonthDate.setSeconds(0);
      currentMonthDate.setMinutes(0);
      currentMonthDate.setMilliseconds(0);
      this.conditions.planTime = currentMonthDate.getTime();
    }
  }
};
</script>
